import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import {
  Account2faDto,
  AccountUserDto,
  TriggerAccountActivationRequest,
  UpsertAccount2faDto,
  UpsertAccountDto
} from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/accounts`;

export const getAllAccountRoles = (source: CancelTokenSource): Promise<Array<string>> => {
  return axios.get(`${apiUri}/roles`, {cancelToken: source.token}).then(response => response.data);
};

export const getAccount2faData = (): Promise<Account2faDto> => {
  return axios.get(`${apiUri}/current-user/two-step-auth`).then(response => response.data);
};

export const setAccount2faData = (account2fa: Partial<UpsertAccount2faDto>) => {
  return axios.post(`${apiUri}/current-user/two-step-auth`, account2fa)
      .then(response => response.data);
};

export const getAccounts = (
    source: CancelTokenSource,
    userSearchTerm?: string): Promise<AccountUserDto[]> => {

  const searchParam = userSearchTerm ? `/${userSearchTerm}` : "";

  return axios.get(`${apiUri}${searchParam}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const validateRegistrationKey = (regKey: string) => {
  return axios.get(`${apiUri}/public/validateRegKey/${regKey}`)
      .then(response => response.data);
};

export const activateAccount = (account: Partial<UpsertAccountDto>) => {
  return axios.post(`${apiUri}/public/activateAccount`, account)
      .then(response => response.data);
};

export const deactivateAccount = (accountId: number) => {
  return axios.post(`${apiUri}/api/account/${accountId}/deactivate`)
      .then(response => response.data);
};

export const resendInvitation = (accountId: number, request: Partial<TriggerAccountActivationRequest>) => {
  return axios.post(`${apiUri}/api/account/${accountId}/resendInvitation`, request)
      .then(response => response.data);
};

export const generateRegKey = (accountId: number, request: Partial<TriggerAccountActivationRequest>) => {
  return axios.post(`${apiUri}/api/account/${accountId}/generateRegKey`, request)
      .then(response => response.data);
};

export const createPraxmedicAccount = (userId: number, request: Partial<TriggerAccountActivationRequest>) => {
  return axios.post(`${apiUri}/api/account/create/${userId}`, request)
      .then(response => response.data);
};
